<template>
  <div id="repository-base">
    <!-- <div
      id="repository-tabs"
      class="sticky z-40 flex items-center gap-8 px-6 border-b repository-tabs bg-pure-white top-18 h-15 border-grey-200"
    >
      <router-link
        v-for="tab in tabs"
        :key="tab.target"
        :to="tab.target"
        class="relative transition-all duration-300"
        :class="{ 'tab-actived': tab.isActive }"
      >
        <BlTextSubtitle2 :text="tab.label" />
      </router-link>
    </div> -->
    <div id="repository-body">
      <Tags v-if="!$route.params.tab" />
      <Databank v-if="$route.params.tab === 'databank'" />
      <Curricula v-if="$route.params.tab === 'curriculum'" />
      <Prompting v-if="$route.params.tab === 'prompting'" />
      <Sbt v-if="$route.params.tab === 'skill-based-treatment'" />
    </div>
  </div>
</template>

<script>
import Tags from "./Tags.vue";
import Databank from "./Databank.vue";
import Curricula from "./Curricula.vue";
import Prompting from "./Prompting.vue";
import Sbt from "./Sbt.vue";

import BlTextSubtitle2 from "../BlTextSubtitle2.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "Repository",
  components: {
    Tags,
    Databank,
    Curricula,
    Prompting,
    Sbt,
    BlTextSubtitle2,
    BlTextBody1,
    BlIcon
  },
  computed: {
    tabs() {
      return [
        {
          target: "/repository",
          isActive: !this.$route.params.tab,
          label: "Tags"
        },
        {
          target: "/repository/databank",
          isActive: this.$route.params.tab === "databank",
          label: "Databank"
        },
        {
          target: "/repository/curriculum",
          isActive: this.$route.params.tab === "curriculum",
          label: "Curricula"
        },
        {
          target: "/repository/prompting",
          isActive: this.$route.params.tab === "prompting",
          label: "Prompting"
        },
        {
          target: "/repository/skill-based-treatment",
          isActive: this.$route.params.tab === "skill-base-treatment",
          label: "Skill Base Treatment"
        }
      ];
    }
  }
};
</script>

<style scoped lang="scss">
.repository-tabs .tab-actived::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.375rem;
  height: 4px;
  background: #6750a4;
  border: 1px solid #6750a4;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/repository/Repository.vue